import MojitoPresentation from 'mojito/presentation';
import MojitoModules from 'mojito/modules';
import SearchEventItem from 'applications/sports/components/search/search-discovery-view/search-event-item/index.js';

const { useEventItem, useMarketItems } = MojitoModules.Common.Hooks;

const { FlexPane, Image, Spinner, Text } = MojitoPresentation.Components;

const SearchEventItemContainer = props => {
    const { config, eventId, marketId, isSearchResult, onNavigate, shouldRequestData } = props;
    // Callers that already chunk-subscribe pass shouldRequestData=false to avoid duplicate requests.
    const event = useEventItem(eventId, shouldRequestData);
    const [market] = useMarketItems([marketId], shouldRequestData);

    if (!event || !market) {
        return null;
    }

    return (
        <SearchEventItem
            config={config}
            event={event}
            market={market}
            isSearchResult={isSearchResult}
            onNavigate={onNavigate}
        />
    );
};

const SearchEventList = props => {
    const {
        emptyText,
        cardInfos,
        isSearchResult,
        onNavigate,
        pending,
        shouldRequestData,
        title,
        mojitoTools,
    } = props;
    const { config } = mojitoTools;

    let content;
    if (pending) {
        content = (
            <FlexPane config={config.loadingContainer} class="ta-searchEventListLoading">
                <Spinner config={config.spinner} />
            </FlexPane>
        );
    } else if (cardInfos.length === 0) {
        content = <Text config={config.emptyText}>{emptyText}</Text>;
    } else {
        content = cardInfos.map(cardInfo => (
            <SearchEventItemContainer
                key={cardInfo.id}
                config={config.item}
                eventId={cardInfo.eventId}
                marketId={cardInfo.marketId}
                isSearchResult={isSearchResult}
                onNavigate={onNavigate}
                shouldRequestData={shouldRequestData}
            />
        ));
    }

    return (
        <FlexPane config={config.container} class="ta-SearchEventList">
            <FlexPane config={config.titleContainer}>
                <Image config={config.titleIcon} />
                <Text config={config.title}>{title}</Text>
            </FlexPane>
            {content}
        </FlexPane>
    );
};

export default SearchEventList;
